
import Vue from 'vue'

export default Vue.extend({
  name: 'ContactNote',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  computed: {
    noteTitle(): string {
      return this.title ? this.title : 'Need helps or special requests for the printing specifications?'
    },
    noteDesc(): string {
      return this.desc ? this.desc : 'Our dedicated team can help you. Feel free to contact us.'
    }
  }
})
